import {employeeTraits} from './payrollEmployeeTraits';

const catalogDefaults = {lineReserveFilter: 'all', lineCitizenshipFilter: 'all', lineHiringFilter: 'all'};
const employeeDefaults = {...catalogDefaults, lineStageFilter: 'all'};
const defaults = {lineQuery: '', lineObjectFilter: 'all', lineCategoryFilter: 'all', lineStatusFilter: 'all', ...employeeDefaults};
const normalize = value => String(value || '').toLocaleLowerCase('ru').replace(/ё/g, 'е');

export default {
    data: () => ({stickySearchOpen: false, stickySearchBusy: false, payrollFiltersExpanded: false, payrollFilterHint: false, ...employeeDefaults,
        lineReserveOptions: [{value: 'all', text: 'Все сотрудники'}, {value: 'other', text: 'Не в резерве'}, {value: 'reserve', text: 'В резерве'},
            {value: 'terminated', text: 'Уволены'}, {value: 'termination_planned', text: 'Увольнение запланировано'}],
        lineStageOptions: [{value: 'all', text: 'Все этапы'}, {value: 'new', text: 'Новые'}, {value: 'adaptation', text: 'Адаптация · 1–3-й месяц'},
            {value: 'review', text: 'Пересмотр условий · 4–5-й месяц'}],
        lineHiringOptions: [{value: 'all', text: 'Любая форма найма'}, {value: 'gph', text: 'ГПХ'}, {value: 'staff', text: 'Штат'}, {value: 'none', text: 'Форма найма не указана'}]
    }),
    watch: {
        payrollFiltersExpanded(expanded) { if (expanded) this.payrollFilterHint = false; },
        lineReserveFilter() { this.selectedLineIds = []; },
        lineStageFilter() { this.selectedLineIds = []; },
        lineCitizenshipFilter() { this.selectedLineIds = []; },
        lineHiringFilter() { this.selectedLineIds = []; }
    },
    computed: {
        extraPayrollFilterCount() {
            return ['lineCategoryFilter', ...Object.keys(employeeDefaults)].filter(key => this[key] !== 'all').length;
        },
        lineCitizenshipOptions() {
            const values = new Set(this.displayLines.map(line => this.lineEmployee(line)).filter(Boolean)
                .map(employee => String(employee.citizenship || '').trim()).filter(Boolean));
            if (this.lineCitizenshipFilter.startsWith('country:')) values.add(this.lineCitizenshipFilter.slice(8));
            return [{value: 'all', text: 'Любое гражданство'}, {value: 'none', text: 'Гражданство не указано'}]
                .concat(Array.from(values).sort((a, b) => a.localeCompare(b, 'ru')).map(text => ({value: `country:${text}`, text})));
        },
        activePayrollFilters() {
            const labels = {lineObjectFilter: ['Объект', this.lineObjectOptions], lineCategoryFilter: ['Категория', this.lineCategoryOptions], lineStatusFilter: ['Состояние', this.lineStatusOptions],
                lineReserveFilter: ['Статус сотрудника', this.lineReserveOptions], lineStageFilter: ['Этап работы', this.lineStageOptions],
                lineCitizenshipFilter: ['Гражданство', this.lineCitizenshipOptions], lineHiringFilter: ['Форма найма', this.lineHiringOptions]};
            return Object.keys(defaults).filter(key => this[key] !== defaults[key]).map(key => {
                const field = labels[key], option = field && field[1].find(option => option.value === this[key]);
                return {key, empty: defaults[key], label: field ? (this[key] === 'none' && option ? option.text : `${field[0]}: ${option ? option.text : this[key]}`) : `Сотрудник: ${this[key]}`};
            });
        }
    },
    methods: {
        hintPayrollFilters() {
            if (!this.payrollFiltersExpanded) this.payrollFilterHint = true;
        },
        resetPayrollEmployeeFilters() { Object.assign(this, employeeDefaults); },
        matchesPayrollEmployeeFilters(line, view) {
            const employee = this.lineEmployee(line);
            const traits = employeeTraits(employee, this.lineAttention(line));
            if (Object.keys(catalogDefaults).some(key => view[key] !== 'all') && !employee) return false;
            if (view.lineReserveFilter === 'reserve' && !traits.reserve) return false;
            if (view.lineReserveFilter === 'other' && (!employee.lifecycle_status || employee.lifecycle_status === 'reserve')) return false;
            if (view.lineReserveFilter === 'terminated' && !traits.terminationDate) return false;
            if (view.lineReserveFilter === 'termination_planned' && !traits.scheduledTerminationDate) return false;
            if (view.lineStageFilter === 'new' && !traits.firstPayroll) return false;
            if (view.lineStageFilter === 'adaptation' && !(traits.stage >= 1 && traits.stage <= 3)) return false;
            if (view.lineStageFilter === 'review' && !(traits.stage >= 4 && traits.stage <= 5)) return false;
            if (view.lineCitizenshipFilter !== 'all') {
                const citizenship = String(employee.citizenship || '').trim();
                if (view.lineCitizenshipFilter === 'none' ? citizenship !== '' : `country:${citizenship}` !== view.lineCitizenshipFilter) return false;
            }
            if (view.lineHiringFilter !== 'all' && (employee.hiring_form || 'none') !== view.lineHiringFilter) return false;
            return true;
        },
        async toggleStickySearch() {
            this.stickySearchOpen = !this.stickySearchOpen;
            if (this.stickySearchOpen) {
                await this.$nextTick();
                this.$refs.stickyEmployeeSearch.focus({preventScroll: true});
            }
        },
        async setStickySearch(value, input) {
            if (this.stickySearchBusy) return;
            this.stickySearchBusy = true;
            try { await this.changePayrollView('lineQuery', value.trim()); }
            finally {
                this.stickySearchBusy = false;
                if (input) input.value = this.lineQuery;
            }
        },
        filterPayrollObjects(options, search) { return options.filter(option => normalize(option.text).includes(normalize(search))); },
        resetPayrollFilters() { return this.changePayrollViewValues({...defaults}); },
        async focusPayrollFilters() {
            this.payrollFiltersExpanded = true;
            await this.$nextTick();
            const panel = this.$refs.payrollFilters;
            if (panel) { panel.scrollIntoView({block: 'center'}); panel.focus({preventScroll: true}); }
        }
    }
};
